module.exports = __webpack_public_path__ + "static/media/ter1.cd59af7f.png";